import { callBackendApi } from "@/utils/common";
import { BiSitemap } from "react-icons/bi";
import Header from "@/components/sitemap-html/header";
import Link from "next/link";

const SitemapHtml = (props) => {
    const { pagesCount } = props;

    return (
        <>
            <Header />
            <div className="container">
                <div className="p-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb m-0">
                            <li className="breadcrumb-item fs-5"><Link href="/sitemap-html"> 
                            <a className="mds-text-primary"><BiSitemap /> Sitemap</a>
                            </Link></li>
                            <li className="breadcrumb-item active fs-5" aria-current="page">Compare Companies</li>
                        </ol>
                    </nav>
                </div>
                <div className="card bg-transparent border-0  mb-5">
                    <ul className="list-group list-group-flush mds-list-group-flush">
                        {new Array(pagesCount).fill(null).map((_, index) =>
                            <li className="list-group-item">
                                <Link href={`/sitemap-html/compare-companies/${index}`}>
                                    <a className="mds-text-primary">Page {index}</a>
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </>

    )
}

export const getServerSideProps = async (context) => {
    const limitPerPage = 150; // limit of vendors in per page

    // get pages count for compare companies
    const allVendorsData = await callBackendApi({
        method: "get",
        url: "/vendors",
        params: {
            select: "slug",
            sort: { createdAt: 1 },
            extraQuery: { countLikes: { $gt: 2 } } // get only vendors which have atleast one like
        }
    }).then(response => response.data.data.map(item => item.slug));

    // create unique url
    let uniqueUrls = [];
    for (let i = 0; i < allVendorsData.length; i++) {
        for (let j = i + 1; j < allVendorsData.length; j++) {
            uniqueUrls.push(`${allVendorsData[i]}-vs-${allVendorsData[j]}`);
        }
    }
    const pagesCount = Math.ceil(uniqueUrls.length / limitPerPage);

    return {
        props: {
            pagesCount
        },
    };
};

export default SitemapHtml;

